<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <loading-screen v-if="!getModelReady" />
    </transition>
    <router-view v-if="appReady" />

    <!-- Menu -->
    <app-menu />
  </div>
</template>

<script>
/* global io, FastClick */
import { mapActions, mapGetters } from 'vuex';
import AppMenu from '@/components/Menu';
import LoadingScreen from '@/components/LoadingScreen';

export default {
  name: 'App',
  components: {
    'app-menu': AppMenu,
    'loading-screen': LoadingScreen
  },
  data() {
    return {
      availabilityEnabled: true,
      refreshInterval: null,
      socket: null,
    };
  },
  methods: {
    ...mapActions({
      clearUnits: 'CLEAR_UNITS',
      fetchFloorplans: 'FETCH_FLOORPLANS',
      fetchSections: 'FETCH_SECTIONS',
      updateUnitAvailability: 'UPDATE_UNIT_AVAILABILITY'
    }),
    initSockets() {
      this.socket = io.connect('https://aws.adhocstudio.ca');
      this.socket.on('connect', () => {
        this.socket.emit('joinProject', this.awsId);
      });
      this.socket.on('unitUpdate', this.updateUnitFromSocket);
      setInterval(this.pingSocket, 180000);
    },
    pingSocket() {
      this.socket.emit('clientPing');
    },
    refreshAvail() {
      this.fetchFloorplans();
    },
    updateUnitFromSocket(e) {
      this.updateUnitAvailability(e);
    }
  },
  computed: {
    ...mapGetters([
      'appReady',
      'awsId',
      'getModelReady',
      'isTouchscreen'
    ])
  },
  created() {
    this.fetchSections()
      .then(this.fetchFloorplans);

    if (window.location.href.indexOf('keeley-demo') > -1) {
      this.availabilityEnabled = false;
    }
    this.availabilityEnabled = false;

    if (this.availabilityEnabled) {
      this.initSockets();

      this.refreshInterval = setInterval(() => {
        this.refreshAvail();
      }, 5 * 60 * 1000, this);
    }

    if (this.isTouchscreen) {
      this.$router.push('/');
    }

    // Enable fast-click
    if ('addEventListener' in document) {
      document.addEventListener('DOMContentLoaded', () => {
        FastClick.attach(document.body);
      }, false);
    }
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

#app {
  font-family: 'FuturaLTW01-Medium', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  user-select: none;
}

.top-auto {
  top: auto;
}

.sticky {
  position: sticky;
}
</style>



// WEBPACK FOOTER //
// src/App.vue